import React from 'react';
import { withTranslation } from 'react-i18next';
import {connect} from 'react-redux';
import DOMPurify from "dompurify";
import { englishFontFallbackMap, arabicFontFallbackMap } from 'src/screens/WhiteLabels/Templates/shared/fonts';
import {
    ThemeProvider,
    StyledEngineProvider,
    createTheme,
} from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import {Dialog,DialogActions,DialogContent,DialogTitle} from "@mui/material";
// components
import '../../assets/stylesheet/addcompany.css';

const TitleTheme = createTheme({
    typography: {
      body1: {
        fontFamily: 'inherit !important',
      },
      h6: {
        fontFamily: 'inherit',
        lineHeight: 3.6,
        textAlign: 'center',
        fontWeight: 'bold',
        // Use theme.breakpoints for responsive styles
        lineHeight: {
          xs: 0, // For 'xs' breakpoint
          sm: 3.6, // Default lineHeight for larger breakpoints
        },
        overflow: {
          xs: 'hidden', // For 'xs' breakpoint
          sm: 'visible', // Default overflow for larger breakpoints
        },
      },
    },
});

const styles = theme => ({
    startBtn:{
        width:'64px',
        height:'40px',
        backgroundColor:'#0F467A',
        border:'1px solid #707070',
        fontWeight:'bold',
        borderRadius:'5px',
        textAlign:'center',
        color:'#fff',
        textTransform:'capitalize',
        fontSize:'13px',
        lineHeight:3,
        cursor:'pointer',
    },

    label:{
        color:'#0F467A',
        fontSize:'16px',
        alignSelf:'flex-start',
        [theme.breakpoints.between('xs','md')]:{
            fontSize:'11px'
        }
    },

    backdrop: {
        zIndex: 111125,
        color: '#fff',
    },

    descInput:{
        border:'1px solid #E9E9E9',
        alignSelf:'center',
        justifyContent: 'start',
        outline: 'none',
        border: 'none',
        backgroundColor: '#F4F6F8',
        fontFamily: "'Cairo', sans-serif",
        width: 'calc(100% - 20px)',
        margin: '10px 0px',
        padding: '10px',
        fontSize: '14px',
        borderRadius: '8px',
        resize: 'none',
        // whiteSpace: 'pre-line',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',

        '& li':{
            listStyle:'inherit'
        }
    },

    actionRoot:{
        padding:'8px 24px',
        justifyContent:'space-between'
    },

    cancelBtn:{
        color:'rgba(0, 0, 0, 0.87)',
        border:'1px solid #E9E9E9',
        backgroundColor:'#F4F6F8'
    },

    title:{
        [theme.breakpoints.between('xs','md')]:{
            padding:'0px 24px'
        }
    }
})

class TermDialog extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onChangeHandle = (agree) => {
        const { onChange, onClose } = this.props;
        onChange(agree);
        onClose(true);
    }

    createMarkup = (data) => {
        const modifed = data.replace(/text-align: right/g,"text-align: right;direction: rtl");
        return {
            __html: DOMPurify.sanitize(modifed)
        };
    };
    
    render() {
        let { classes,t, i18n, termArray, companyName, dispatch,onClose,tReady, companyFonts, ...other } = this.props;
        const isRTL = i18n.translator.language;
        const englishFont = englishFontFallbackMap[companyFonts?.englishFont] || "'Poppins', serif";
        const arabicFont = arabicFontFallbackMap[companyFonts?.arabicFont] || '"Cairo", sans-serif';
        const fontFamily = isRTL === 'ar' ? arabicFont : englishFont;
    return (
        (<React.Fragment>
            <Dialog
                {...other}
                disableEscapeKeyDown
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                dir={isRTL === 'ar' ? 'rtl' : 'ltr'}
                style={{fontFamily}}
                fullWidth={true}
                maxWidth='sm'>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={TitleTheme}>
                            <DialogTitle id="alert-dialog-title" classes={{root:classes.title}} style={{fontFamily}}>{companyName ? companyName : '---'}</DialogTitle>
                    </ThemeProvider>
                </StyledEngineProvider>
                <DialogContent style={{display:'flex',flexDirection:'column'}}>
                    <div className='activityTimePicker'>
                        <span className={classes.label} style={{fontFamily,marginBottom:'10px'}}>{t('booking.term')}</span>
                        {termArray.length > 0 && React.Children.toArray(termArray.map(v=> {
                            return(
                                <>
                                    <span className={classes.label} style={{fontFamily,textTransform:'capitalize',fontWeight:'bold'}}>{v.serviceName}</span>
                                    <div className={classes.descInput}
                                    dangerouslySetInnerHTML={this.createMarkup(v.termText)}
                                    ></div>
                                </>
                            )
                        }))}
                    </div>
                </DialogContent>
                <DialogActions classes={{root:classes.actionRoot}}>
                    <div className={`${classes.startBtn} ${classes.cancelBtn}`} style={{fontFamily}} onClick={()=> onClose(false)}>
                        {t('upgrade-dialog.can')}
                    </div>
                    <div className={classes.startBtn} style={{fontFamily}} onClick={()=> this.onChangeHandle(true)}>
                        {t('booking.agree')}
                    </div>
                </DialogActions>
            </Dialog>
        </React.Fragment>)
    );
    }
}

const mapStateToProps = state => {
    return{
        user : state.user,
        company: state.company,
        lang: state.lang,
        companyFonts: state.cpFonts,
    }
}

export default connect(mapStateToProps,null)(withStyles(styles)(withTranslation('common')(TermDialog)));